export const ModalMixin = {
    props: {
        deferUpdateEvent: { type: Boolean, default: false },  // если true, то при updateData != null событие обновления отправится при нажатии на отмену
    },
    data() {
        return {
            updateData: null
        }
    },
    methods: {
        onCancel() {
            if (this.deferUpdateEvent && this.updateData) {
                this.$emit('object-modal-updated', this.updateData);
            }
            this.$emit('object-modal-closed');
        },
        onCreate() {
            this.submitAction().then((response) => {
                this.$emit('object-modal-created', response.data);
            })},
        onUpdate() {
            this.submitAction().then((response) => {
                if (this.deferUpdateEvent) {
                    this.updateData = response.data
                } else {
                    this.$emit('object-modal-updated', response.data);
                }
            })
        }
    }
}